import { useAuth, type Me } from '../../lib/auth';
import { post } from '../../lib/api';
import { Button } from '@exam-prep/ui';
import { CodeForm } from './ui/Login';

export function StepUpDialog() {
  const { stepUp, finishStepUp, setMe } = useAuth();
  if (!stepUp) return null;
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-[color-mix(in_srgb,var(--brand-c-deep)_55%,transparent)] p-4 backdrop-blur-sm"
      role="dialog"
      aria-modal="true"
      aria-labelledby="step-up-title"
    >
      <div className="w-full max-w-sm rounded-2xl border border-input bg-[var(--brand-surface-strong)] p-5 shadow-[0_30px_80px_-20px_rgb(0_0_0/0.7),0_0_40px_-20px_var(--brand-glow-amber)]">
        <h2 id="step-up-title" className="text-base font-semibold">
          Confirm it's you
        </h2>
        <p className="mb-3 text-sm text-muted-foreground">
          This action needs a fresh code from your authenticator app.
        </p>
        <CodeForm
          cta="Confirm"
          onSubmit={async (code) => {
            setMe(await post<Me>('/admin/auth/step-up', { code }));
            finishStepUp(true);
          }}
        />
        <Button variant="ghost" className="mt-2 w-full" onClick={() => finishStepUp(false)}>
          Cancel
        </Button>
      </div>
    </div>
  );
}
